import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import T, { SUPPORTED_LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

function detectInitialLang() {
  const saved = typeof window !== "undefined" ? window.localStorage.getItem("b2bps.lang") : null;
  if (saved && T[saved]) return saved;
  const browser = typeof navigator !== "undefined" ? (navigator.language || "en").toLowerCase().slice(0, 2) : "en";
  if (browser === "ht" || browser.startsWith("ht")) return "ht";
  if (T[browser]) return browser;
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);

  useEffect(() => {
    window.localStorage.setItem("b2bps.lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    return T[lang]?.[key] ?? T.en[key] ?? key;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, langs: SUPPORTED_LANGS }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
